/** Clave localStorage; incrementar versión (v2, v3…) si se publica un cambio sustancial del aviso. */
export const PRIVACY_NOTICE_STORAGE_KEY = 'ivisnk9-inspector-privacy-notice-v1';
